import stl from "./carDetailsSection.module.css";
import ProgressiveImage from "@componentsShared/ProgressiveImage";

const SingleCarCC = (props) => {
    return (
        <div className={stl.CCContainer} aria-label={props.title}>
            <ProgressiveImage
                waitUntilInteractive
                src={props.icon}
                alt="icon"
                width={24}
                height={24}
                loading="lazy"
            />
            <label>{props.title}:</label>
            <strong>{props.field}</strong>
            {props.colorCode && (
                <div
                    className={stl.colorBox}
                    style={{backgroundColor: props.colorCode}}
                />
            )}
        </div>
    );
};

export default SingleCarCC;
